module.exports = __webpack_public_path__ + "static/media/touchwood.59fcd594.png";